import { useState } from 'react';
import { ChevronDown, ChevronUp } from 'react-bootstrap-icons';
import { useNavigate, useParams } from 'react-router-dom';
import Table, { Column } from '../../../Components/Tables/Table';
import ExpandableKitOrderContentLayout from '../../../Layout/ExpandableKitOrderContentLayout';
import PageHeader from '../../../Layout/PageHeader';
import historyIcon from "../../../assets/images/history-icon.svg";
import { HistoryLaoutDataKitOrderDetail, kitOrderDetailsList } from '../../../Data/testData';
import DynamicDetailGrid from '../../../Components/Grid/DynamicDetailGrid';
import HistoryLayout from '../../../Layout/HistoryLaout';


export default function KitOrderDetails() {
    const navigate = useNavigate();
    const { id } = useParams<{ id: string }>();
    const pageName = `Kit Orders (${id})`;

    const [collapseStates, setCollapseStates] = useState<boolean[]>([false]);
    const toggleCollapse = (index: number) => {
        const updatedCollapseStates = [...collapseStates];
        updatedCollapseStates[index] = !updatedCollapseStates[index];
        setCollapseStates(updatedCollapseStates);
    };

    const [isShowCanvas, setShowCanvas] = useState(false);
    const handelCanvas = () => {
       setShowCanvas(!isShowCanvas);
    };

    const historyData = (

        <div
            className="d-flex justify-content-between w-100 align-items-center px-4"
            onClick={handelCanvas}
        >
            <div>
                <h6 className="cursor-pointer m-0 d-flex align-items-center">
                    <img src={historyIcon} className="me-2" alt="no image" />
                    History
                </h6>
            </div>
        </div>

    );
    const columns: Column[] = [
        {
            name: "Kit Part#",
            selector: (row: { kit_part: string }) => row.kit_part,
        },
        {
            name: "Kit Description",
            selector: (row: { kit_desc: string }) => (
                <span   title={row.kit_desc.length > 15 ? row.kit_desc : ""}>
                {row.kit_desc.length > 15
                  ? `${row.kit_desc.slice(0, 15)}...`
                  : row.kit_desc}
              </span>
            ),
        },
        {
            name: "Kit Order Qty",
            selector: (row: { kit_order_qty: string }) => row.kit_order_qty,
        },
        {
            name: "Kit Available",
            selector: (row: { kit_available: string }) => row.kit_available,
        }
    ];

    const KitOrderDetailsData = {
        KitOrdersDetailsExpanded:
            [
                { label: 'Kit Order Date', value: "06/12/2021" },
                { label: 'Form Inv Status', value: "Found Goods" },
                { label: 'To Inv Status', value: "Finished Goods" },
                { label: 'Drop Location', value: "A1-A-P1" },
                { label: 'Status', value: (
                        <>
                            <div className="text-dark w-auto px-4 badge asn-overview-status w-70 asn-overview-status-border-blue">
                                New
                            </div>
                        </>
                    )
                }
            ],

        KitOrdersDetailsDefault:[
            { label: 'Kit Order Date', value: "06/12/2021" },
            { label: 'Form Inv Status', value: "Found Goods" },
            { label: 'To Inv Status', value: "Finished Goods" },
        ]
    }


    return (
        <>

            <PageHeader
                listUrl={`/inventory/assembly/kit-orders`}
                viewType={true}
                isHistoryEnabled={true}
                historyData={[historyData]}
            />

            <h5 className="text-start mt-1 mb-3">{pageName}</h5>
            <div className="my-2 bg-white rounded py-1 px-2 d-flex flex-column">
                <div className="checkin-details col-12 bg-white col-12 py-1  px-2 ">
                    {collapseStates[0] ? (
                        <div className="checkin-details row align-items-top d-flex bg-white col-12  px-5 ">

                            <DynamicDetailGrid customClassName="my-2 col-10" isExpandable={false} columns={3} data={KitOrderDetailsData.KitOrdersDetailsExpanded} />
                          
                            <div className="col-2">
                                <div className="align-self-center d-flex flex-row-reverse my-4">
                                    <span
                                        className="badge rounded-pill sph-text-bg-light-grey cursor-pointer fs-6 my-1"
                                        onClick={() => toggleCollapse(0)}
                                    >
                                        {collapseStates[0] ? <ChevronUp /> : <ChevronDown />}
                                    </span>
                                </div>
                            </div>
                        </div>
                    ) : (
                        <div className="checkin-details row align-items-center d-flex bg-white col-12 px-5 ">
                            <DynamicDetailGrid customClassName="my-2 col-10" isExpandable={false} columns={3} data={KitOrderDetailsData.KitOrdersDetailsDefault} />
                            <div className="col-2">
                                <div className="align-self-center d-flex flex-row-reverse">
                                    <span
                                        className="badge rounded-pill sph-text-bg-light-grey cursor-pointer fs-6 "
                                        onClick={() => toggleCollapse(0)}
                                    >
                                        {collapseStates[0] ? <ChevronUp /> : <ChevronDown />}
                                    </span>
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </div>
            <div className="my-2 rounded bg-white py-1 px-2 h-100">
                <Table
                    columns={columns}
                    data={kitOrderDetailsList}
                    CheckboxStatus={false}
                    customClassName="kitOrderDetailsTable transferDetailsTable"
                    isStripped={true}
                    isExpandable={true}
                    expandableContentLayout={(row: any) => (
                        <ExpandableKitOrderContentLayout row={row} />
                    )}
                />
            </div>
            <HistoryLayout  isShowCanvas={isShowCanvas}
             handelCanvas={handelCanvas} data={HistoryLaoutDataKitOrderDetail} />
        </>
    )

}